
import {easeOut} from 'ol/easing';

import MapCommand from './MapCommand';

export default class MapCommandZoom extends MapCommand {

    execute(olMap) {
        const view = olMap.getView();
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + this._options.delta);

            view.animate({
                zoom: newZoom,
                duration: 250,
                easing: easeOut
            });
        }
    }
}
